import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=9888159a&"
import script from "./Recover.vue?vue&type=script&lang=js&"
export * from "./Recover.vue?vue&type=script&lang=js&"
import style0 from "./Recover.vue?vue&type=style&index=0&id=9888159a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/login/Recover.vue
// module id = 946
// module chunks = 0